"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fitTextOnNLines = void 0;
const fill_text_box_1 = require("./fill-text-box");
const PRECISION = 100;
const fitTextOnNLines = ({ text, maxLines, maxBoxWidth, fontFamily, fontWeight, letterSpacing, fontVariantNumeric, validateFontIsLoaded, textTransform, additionalStyles, maxFontSize, }) => {
    // Fixed max font size since we are using binary search a
    const minFontSize = 0.1;
    // Binary search to find the optimal font size
    let left = Math.floor(minFontSize * PRECISION);
    let right = Math.floor((maxFontSize !== null && maxFontSize !== void 0 ? maxFontSize : 2000) * PRECISION);
    let optimalFontSize = minFontSize;
    let optimalLines = [];
    while (left <= right) {
        const mid = Math.floor((left + right) / 2);
        const fontSize = mid / PRECISION;
        // Create a text box with current font size
        const textBox = (0, fill_text_box_1.fillTextBox)({
            maxBoxWidth,
            maxLines,
        });
        // Split text into words and try to fit them
        const words = text.split(' ');
        let exceedsBox = false;
        let currentLine = 0;
        const lines = [''];
        for (const word of words) {
            const result = textBox.add({
                text: word + ' ',
                fontFamily,
                fontWeight,
                fontSize,
                letterSpacing,
                fontVariantNumeric,
                validateFontIsLoaded,
                textTransform,
                additionalStyles,
            });
            if (result.exceedsBox) {
                exceedsBox = true;
                break;
            }
            if (result.newLine) {
                lines.push('');
                currentLine++;
            }
            lines[currentLine] += word + ' ';
        }
        // If text fits within the box and number of lines
        if (!exceedsBox && currentLine < maxLines) {
            optimalFontSize = fontSize;
            optimalLines = lines;
            left = mid + 1;
        }
        else {
            right = mid - 1;
        }
    }
    return {
        fontSize: optimalFontSize,
        lines: optimalLines,
    };
};
exports.fitTextOnNLines = fitTextOnNLines;
